import React, { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { postAxios } from "../Services/commonService";
import { API_POST_POSITION } from "../utils/api/ApiConstant";
import { Button, DataTable, SubHeading } from "../Components";
import TradeListModal from "./TradeListModal";
import CommonModal from "./CommonModal";
import UserwisePosition from "./UserwisePosition";
import { usePosition } from "../Hooks";

const PositionModal = ({ rowData, handleShowHide, payloadData }) => {
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const { usePositionQuery, positionList, totalPages } = usePosition({
    queryKey: "positionListModal",
    payload: {
      server: payloadData.server,
      showIndividually: true,
      ScriptToken: rowData?.ScriptToken,
    },
    isAllData: true,
  });

  const createClickableCell = () => {
    return ({ row, getValue }) => {
      const handleClick = () => {
        setIsShow((prev) => ({
          ...prev,
          isOpen: true,
          rowData: row.original,
          name: "TradeListModal",
          modalTitle: "Trade List",
          modalContent: TradeListModal,
        }));
      };

      return (
        <div style={{ cursor: "pointer" }} onClick={handleClick}>
          {getValue()}
        </div>
      );
    };
  };

  const columns = useMemo(
    () => [
      {
        header: "Userwise",
        cell: ({ row }) => {
          const handleClick = () => {
            setIsShow((prev) => ({
              ...prev,
              isOpen: true,
              rowData: row.original,
              name: "UserwisePosition",
              modalTitle: "Userwise Position",
              modalContent: UserwisePosition,
            }));
          };
          return (
            <Button className="btn-primary py-1 px-2" onClick={handleClick}>
              View
            </Button>
          );
        },
      },
      {
        accessorKey: "ServerName",
        header: "Server",
        cell: createClickableCell(),
      },
      // { accessorKey: "ScriptToken", header: "ScriptToken" },
      {
        accessorKey: "ExchangeName",
        header: "Exchange",
        cell: createClickableCell(),
      },
      { accessorKey: "Script", header: "Script", cell: createClickableCell() },

      // {
      //   accessorKey: "Description",
      //   header: "Description",
      //   cell: createClickableCell(),
      // },
      // { accessorKey: "LotSize", header: "LotSize" },
      {
        accessorKey: "Position",
        header: "Position",
        cell: createClickableCell(),
      },
      {
        accessorKey: "OpenQuantity",
        header: "OpenQty",
        cell: createClickableCell(),
      },
      {
        accessorKey: "BuyQty",
        header: "BuyQty",
        cell: createClickableCell(),
      },
      {
        accessorKey: "SellQty",
        header: "SellQty",
        cell: createClickableCell(),
      },
      {
        accessorKey: "OpenAvgRate",
        header: "AvgRate",
        cell: createClickableCell(),
      },
      {
        accessorKey: "CurrentMapPrice",
        header: "CMP",
        cell: createClickableCell(),
      },
      // {
      //   accessorKey: "ExpiryDate",
      //   header: "ExpiryDate",
      //   cell: createClickableCell(),
      // },
      {
        accessorKey: "ExpiryDateText",
        header: "Exp.Date",
        cell: createClickableCell(),
      },
      {
        accessorKey: "ProfitLoss",
        header: "P&L",
        cell: createClickableCell(),
      },
    ],
    []
  );

  return (
    <>
      <DataTable
        columns={columns}
        data={positionList || []}
        pages={totalPages}
        isLoading={usePositionQuery?.isLoading}
        isSearchable={false}
        isPagination={false}
        isPageSize={false}
      />

      <CommonModal
        isShow={isShow.isOpen}
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: false,
            rowData: {},
            name: "",
          }))
        }
        modalTitle={isShow.modalTitle}
      >
        {isShow.modalContent &&
          React.createElement(isShow.modalContent, {
            handleShowHide: () =>
              setIsShow((prev) => ({
                ...prev,
                isOpen: false,
                rowData: {},
                name: "",
                modalTitle: "",
                apiFlag: !prev.apiFlag,
              })),
            rowData: isShow.rowData,
          })}
      </CommonModal>
    </>
  );
};

export default PositionModal;
